import { useQuery } from '@tanstack/react-query';
import { getMetric } from '../../api/metrics';
import { useEnvironment } from '../useEnvironment/useEnvironment';
import type { WidgetSpec } from '../../dashboard/spec';

export const useMetric = (spec: Pick<WidgetSpec, 'metric' | 'group_by' | 'range'>) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['metric', environment, spec.metric, spec.group_by, spec.range],
    queryFn: () =>
      getMetric(environment, { metric: spec.metric, group_by: spec.group_by, range: spec.range }),
    select: ({ data }) => data,
    staleTime: 60_000,
  });
};
